export default {
    create_company: 'Выберите ваш поддомен',
    invoice_info: 'Счета выставляются первого числа каждого месяца за предыдущий месяц',
    congratulations: 'Поздравляем!',
    became_a_partner: 'Вы стали партнером Bookeraj',
    partner_info_one:
        'Важно знать, что вы можете отписаться или изменить свой план в любое время. Изменения плана вступят в силу с 1-го числа следующего месяца',
    partner_info_two: 'Если вам нужна помощь, не стесняйтесь обращаться к нам на странице контактов или через социальные сети.',
    go_to_your_company: 'Перейти к вашей компании',
    enter_subdomain: 'Введите ваш поддомен',
    subdomain: 'Поддомен',
    subdomain_footnote: 'При вводе поддомена ваш сайт будет активен под ним.',
    choose_theme: 'Выберите тему',
    view: 'Просмотр',
    enter_company_details: 'Введите данные о компании',

    progressbar: {
        create_step: 'Данные компании',
        package_step: 'Выбор пакета',
        finish_step: 'Финальный шаг',
    },

    package_step: {
        title: 'Выберите ваш пакет',
        description: 'Начните первый месяц бесплатно. Кредитная карта не требуется.',
        monthly: 'Ежемесячно',
        yearly: 'Ежегодно',
        button: 'Начать бесплатно',
        basic: {
            title: 'Базовый',
            option1: 'Первый месяц бесплатно',
            option2: 'Неограниченные услуги',
            option3: 'Неограниченные бронирования',
            option4: 'Неограниченное количество сотрудников',
            option5: 'Неограниченное количество локаций',
            option6: 'Настройки неактивности',
            option7: 'Настройка профиля',
            option8: 'Клиентская база и возможность блокировки пользователей',
        },
        pro: {
            title: 'Профессиональный',
            option1: 'Первый месяц бесплатно',
            option2: 'Неограниченные услуги',
            option3: 'Неограниченные бронирования',
            option4: 'Неограниченное количество сотрудников',
            option5: 'Неограниченное количество локаций',
            option6: 'Настройки неактивности',
            option7: 'Настройка профиля',
            option8: 'Отдельный сайт бронирования исключительно для вашей компании',
            option9: 'Настройка вашего веб-сайта (выбор темы, изображений, описания)',
            option10: 'Поддомен с вашим веб-сайтом',
            option11: 'Стикер с QR кодом',
            option12: 'Клиентская база и возможность блокировки пользователей',
        },
        invoice_info: 'Счета выставляются первого числа каждого месяца за предыдущий месяц',
    },
}
